export default "__VITE_ASSET__89c41d48__"